import { Box, Typography } from '@mui/material';

export const EmptyContent = () => {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box component='img' src={'/png/access-blocked-empty@2x.png'} />
      <Typography sx={{ width: '200px', textAlign: 'center', marginTop: 4 }}>
        Users you've blocked will be displayed here
      </Typography>
    </Box>
  );
};
